/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".checkbox-list[_ngcontent-%COMP%]{margin:0;padding:0;list-style-type:none}.checkbox-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{-moz-column-count:2;column-count:2}.permission-group[_ngcontent-%COMP%]{margin-bottom:10px}"];
export { styles as styles };
